<template>
  <div class="row mx-auto">
    <div class="col-12 col-md-6 p-3 mx-auto">
      <h1 class="mt-4 mb-4 text-center">Liste des {{ changeTitle }}</h1>
      <section class="mt-3 mb-3">
        <b-card class="text-center">
          <b-button
            @click="downloadCsv()"
            variant="primary"
            class="center m-5 mb-3"
          >
            Télécharger le csv
          </b-button>
        </b-card>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Values",
  props: {
    exportName: {
      type: String,
      default: "",
      required: true
    }
  },
  computed: {
    changeTitle() {
      return this.exportName === "values"
        ? "Valeurs"
        : this.exportName === "categories"
        ? "Catégories"
        : "Mappings";
    },
    downloadTitle() {
      return this.exportName === "values"
        ? "Values"
        : this.exportName === "categories"
        ? "Categories"
        : "Mappings";
    }
  },
  methods: {
    forceDownload(res, title) {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    Majuscule(nom) {
      return nom.charAt(0).toUpperCase() + nom.substring(1).toLowerCase();
    },
    async downloadCsv() {
      await this.$gwzApi
        .service(this.downloadTitle.toLowerCase())
        [`download${this.downloadTitle}AsCsv`]()
        .then(res => {
          this.forceDownload(res, `${this.exportName}.csv`);
          this.$store.dispatch("setSuccessToast", "Téléchargement en cours");
        })
        .catch(err => {
          this.$store.dispatch("setErrorToast", err["hydra:description"]);
        });
    }
  }
};
</script>

<style></style>
